import axios from '../../utils/axios'
import CustomError from '../../utils/custom-error'

const MULTIPLE_DOCUMENT_ERROR = 'Multiple document error'

export const sendToLocalSigner = async (data, url) => {
    
  const signerURL = window.navigator.userAgent.includes("Mac")
    ? `${url}:${process.env.REACT_APP_OSX}`
    : `${url}:${process.env.REACT_APP_WIN}`


  try {
    if (data.documents.length !== 1) {
      throw new CustomError(MULTIPLE_DOCUMENT_ERROR, { message: MULTIPLE_DOCUMENT_ERROR ,code: 22})
    }
    
    //throw new CustomError(MULTIPLE_DOCUMENT_ERROR, { message: MULTIPLE_DOCUMENT_ERROR ,code: 8})
    // ovo je radi sva 
    const hashesForSign =  data.documents[0].hash.split(":")
    const hash = hashesForSign.length === 2 ? hashesForSign[1] : hashesForSign[0]
    //
    //const hash = data.documents[0].hash
    const verificationCode = data.documents[0].verificationCode
    const mimetype = data.mimetype
    const response = await axios.post(signerURL, {
      mimetype,
      verificationCode,
      hash
    })
    // trenutni response: signerCertificate, signedHash
    
    // treba vrati response:
    // { documents: [ hash:xxx, signedHash, verCode:], userCert}
    /**
     * Trenutno Local signer vraća josn response
     *  {
     *   signedHash: "XXXX",
     *   signerCertificate: "XXXX"
     * }
     * zato formatiram response...
     */
    const responseData = {
      documents: [{...data.documents[0], signedHash: response.data.signedHash, timeStamp: response.data.timeStamp}],
      userCertificate: response.data.signerCertificate
    }
    return responseData
  } catch (error) {   
    console.log('error dat local signer...', error )
    throw error
  }
  
}